import { DS_BUTTON_SIZE, DS_BUTTON_VARIANT, DSButtonSize, DSButtonVariant } from "../types/props";
import { DS_ICON_SIZES, DSIconSize } from "@/src/design_system/primitives/icon/types";
import { DS_ALIGN } from "@/src/design_system/shared/types/align";

export const DS_BUTTON_CLASSES = {
  Root: "ds-button",
  VariantPrimary: "ds-button--primary",
  VariantSecondary: "ds-button--secondary",
  VariantTertiary: "ds-button--tertiary",
  VariantGhost: "ds-button--ghost",
  FullWidth: "ds-button--full-width",
  AlignLeft: "ds-button--left",
} as const;

export const DS_BUTTON_VARIANT_TO_CLASS_MAP: Record<DSButtonVariant, string> = {
  [DS_BUTTON_VARIANT.Primary]: DS_BUTTON_CLASSES.VariantPrimary,
  [DS_BUTTON_VARIANT.Secondary]: DS_BUTTON_CLASSES.VariantSecondary,
  [DS_BUTTON_VARIANT.Tertiary]: DS_BUTTON_CLASSES.VariantTertiary,
  [DS_BUTTON_VARIANT.Ghost]: DS_BUTTON_CLASSES.VariantGhost,
} as const;

export const DS_BUTTON_SIZE_TO_ICON_SIZE_MAP: Record<DSButtonSize, DSIconSize> = {
  [DS_BUTTON_SIZE.ExtraSmall]: DS_ICON_SIZES.ExtraSmall,
  [DS_BUTTON_SIZE.Small]: DS_ICON_SIZES.Small,
  [DS_BUTTON_SIZE.Medium]: DS_ICON_SIZES.Medium,
  [DS_BUTTON_SIZE.Large]: DS_ICON_SIZES.Medium,
} as const;

export const DS_BUTTON_ALIGN_TO_CLASS_MAP = {
  [DS_ALIGN.Left]: DS_BUTTON_CLASSES.AlignLeft,
} as const;
